import axios from "axios";
import { Branch_Contact_URL } from "../Url";
import HashMap from "hashmap";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
export const branchSaveAllActions = {
  BRANCH_SAVEALL_LOADING: "BRANCH_SAVEALL_LOADING",
  BRANCH_SAVEALL_SUCCESS: "BRANCH_SAVEALL_SUCCESS",
  BRANCH_SAVEALL_ERROR: "BRANCH_SAVEALL_ERROR",
};

export const branchSaveAllDetails = (props) => {
  const { accessToken, partnerFirmId, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      url: `${Branch_Contact_URL}/saveAllBranchDetails?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(branchSaveAllSuccess(response.data.dto));

          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(branchSaveAllError(error));

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          dispatch(branchSaveAllError(err));
          return err;
        } else if (!err.response) {
        }
      });
};

export const branchSaveAllSuccess = (props) => {
  return {
    type: branchSaveAllActions.BRANCH_SAVEALL_SUCCESS,
    payload: props,
  };
};

export const branchSaveAllError = (props) => {
  return {
    type: branchSaveAllActions.BRANCH_SAVEALL_ERROR,
    payload: props,
  };
};

export const branchSaveAllLoading = () => {
  return {
    type: branchSaveAllActions.BRANCH_SAVEALL_LOADING,
  };
};
